import {Module, Mutation, VuexModule} from 'vuex-module-decorators';
import Store from './index';
import {EbyMessage} from "@/entity/EbyMessage";


@Module({
    store: Store,
    name: 'BaseStore',
    dynamic: true,
})
export class BaseStore extends VuexModule {
    public leftDrawerOpen = false;
    
    @Mutation
    public setLeftDrawerOpen(b: boolean) {
        this.leftDrawerOpen = b;
    }

    //易购商城接受的消息
    public ebyMessage =new EbyMessage()
    @Mutation
    public setYgMessage(tabName: string){
        this.ebyMessage.tabName =tabName
    }
    @Mutation
    public setYgUrl(url: string){
        this.ebyMessage.url = url
    }
    @Mutation
    public setPhone(phone: string){
        this.ebyMessage.phone = phone
    }
    @Mutation
    public setPersonName(personName: string){
        this.ebyMessage.personName= personName
    }
    
}
